/* ============================================================
   Anniversary Quiz — JavaScript
   ============================================================ */
(function () {
  'use strict';

  /* ── Grab section elements ── */
  var section = document.querySelector('.aniversary-participate-form');
  var formWrapper = document.querySelector('.participate-form__wrapper');
  if (!section || !formWrapper) return;

  /* ── Read quiz data from script tag ── */
  function getQuizData() {
    var quizDataEl = document.getElementById('anniversary-quiz-data');
    if (!quizDataEl) return [];
    try { return JSON.parse(quizDataEl.textContent); } catch (e) { return []; }
  }

  /* ── Read google settings from script tag ── */
  function getGoogleSettings() {
    var settingsEl = document.getElementById('anniversary-google-settings');
    if (!settingsEl) return {};
    try { return JSON.parse(settingsEl.textContent); } catch (e) { return {}; }
  }

  var googleSettings = getGoogleSettings();

  var quizQuestions = getQuizData();
  if (!quizQuestions.length) return;

  /* ── State ── */
  var currentQ   = 0;
  var answers    = [];
  var timerID    = null;
  var timeLeft   = 0;

  /* ── Build Popup HTML ── */
  var overlay = document.createElement('div');
  overlay.className = 'quiz-overlay';
  overlay.id = 'anniversary-quiz-overlay';

  var stepsHTML = quizQuestions.map(function (_, i) {
    return (i > 0 ? '<span class="quiz-step-connector"></span>' : '') +
           '<span class="quiz-step-dot" data-qdot="' + i + '">' + (i + 1) + '</span>';
  }).join('');

  overlay.innerHTML =
    '<div class="quiz-modal" id="anniversary-quiz-modal">' +
      '<div class="quiz-steps">' + stepsHTML + '</div>' +
      '<div class="quiz-timer-wrapper">' +
        '<div class="quiz-timer-container">' +
          '<svg class="quiz-timer-svg" width="56" height="56" viewBox="0 0 56 56">' +
            '<circle class="quiz-timer-bg" cx="28" cy="28" r="24"/>' +
            '<circle class="quiz-timer-ring" id="quiz-timer-ring" cx="28" cy="28" r="24"/>' +
          '</svg>' +
          '<span class="quiz-timer-label" id="quiz-timer-label">00:10</span>' +
        '</div>' +
      '</div>' +
      '<div class="quiz-question-area">' +
        '<p class="quiz-question-text" id="quiz-question-text"></p>' +
      '</div>' +
      '<div class="quiz-options" id="quiz-options"></div>' +
      '<button class="quiz-next-btn" id="quiz-next-btn" disabled>Next Question</button>' +
    '</div>';

  /* Append within section to overlay the entire section */
  section.style.position = 'relative';
  section.appendChild(overlay);

  /* ── DOM refs ── */
  var modal        = document.getElementById('anniversary-quiz-modal');
  var questionText = document.getElementById('quiz-question-text');
  var optionsWrap  = document.getElementById('quiz-options');
  var nextBtn      = document.getElementById('quiz-next-btn');
  var timerLabel   = document.getElementById('quiz-timer-label');
  var timerRing    = document.getElementById('quiz-timer-ring');
  var dots         = document.querySelectorAll('[data-qdot]');

  var CIRC = 2 * Math.PI * 24;
  timerRing.style.strokeDasharray  = CIRC;
  timerRing.style.strokeDashoffset = 0;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function updateDots() {
    dots.forEach(function (d, i) {
      d.classList.remove('is-active', 'is-done');
      if (i < currentQ)      d.classList.add('is-done');
      else if (i === currentQ) d.classList.add('is-active');
    });
  }

  function startTimer(seconds) {
    clearInterval(timerID);
    timeLeft = seconds;
    timerLabel.textContent = '00:' + pad(timeLeft);
    timerRing.style.strokeDashoffset = 0;

    timerID = setInterval(function () {
      timeLeft--;
      var offset = CIRC * (1 - timeLeft / seconds);
      timerRing.style.strokeDashoffset = offset;
      timerLabel.textContent = '00:' + pad(Math.max(timeLeft, 0));
      if (timeLeft <= 0) {
        clearInterval(timerID);
        autoAdvance();
      }
    }, 1000);
  }

  function autoAdvance() {
    if (!answers[currentQ]) {
      answers[currentQ] = { selected: null, correct: quizQuestions[currentQ].correct };
    }
    advanceQuestion();
  }

  function renderQuestion(index) {
    var q = quizQuestions[index];
    questionText.textContent = q.question;
    optionsWrap.innerHTML = '';
    q.options.forEach(function (opt, i) {
      if (!opt) return;
      var btn = document.createElement('button');
      btn.className = 'quiz-option';
      btn.textContent = opt;
      btn.dataset.idx = i + 1;
      btn.addEventListener('click', function () { selectOption(btn, index); });
      optionsWrap.appendChild(btn);
    });

    var isLast = (index === quizQuestions.length - 1);
    nextBtn.textContent = isLast ? 'Submit' : 'Next Question';
    nextBtn.disabled = true;
    nextBtn.classList.remove('is-ready');

    updateDots();
    startTimer(q.timer || 10);
  }

  function selectOption(btn, qIndex) {
    optionsWrap.querySelectorAll('.quiz-option').forEach(function (b) {
      b.classList.remove('is-selected');
    });
    btn.classList.add('is-selected');
    answers[qIndex] = { selected: parseInt(btn.dataset.idx), correct: quizQuestions[qIndex].correct };
    nextBtn.disabled = false;
    nextBtn.classList.add('is-ready');
  }

  function advanceQuestion() {
    clearInterval(timerID);
    dots[currentQ].classList.remove('is-active');
    dots[currentQ].classList.add('is-done');

    if (currentQ < quizQuestions.length - 1) {
      currentQ++;
      renderQuestion(currentQ);
    } else {
      finishQuiz();
    }
  }

  nextBtn.addEventListener('click', function () {
    if (!nextBtn.classList.contains('is-ready')) return;
    advanceQuestion();
  });

  function openQuiz() {
    currentQ = 0;
    answers  = [];
    overlay.classList.add('quiz-overlay--active');
    renderQuestion(0);
  }

  function finishQuiz() {
    clearInterval(timerID);
    dots[currentQ].classList.remove('is-active');
    dots[currentQ].classList.add('is-done');

    var resultSummary = answers.map(function (a, i) {
      if (!a || a.selected === null) return 'No Answer';
      var optionText = quizQuestions[i].options[a.selected - 1];
      var isCorrect = (a.selected === a.correct);
      return optionText + (isCorrect ? ' (Correct)' : ' (Wrong)');
    });

    window._quizAnswers = {
      q1: resultSummary[0] || 'No Answer',
      q2: resultSummary[1] || 'No Answer',
      q3: resultSummary[2] || 'No Answer',
      q4: resultSummary[3] || 'No Answer',
      q5: resultSummary[4] || 'No Answer'
    };

    overlay.classList.remove('quiz-overlay--active');

    var step2 = document.querySelector('.participate-step[data-step="2"]');
    if (step2) step2.classList.add('active');

    var submitBtn = document.querySelector('.participate-form__submit-btn');
    if (submitBtn) {
      submitBtn.textContent = 'Confirm Your Entry';
      submitBtn.dataset.quizDone = '1';
    }

    var heading = document.querySelector('.participate-form__heading');
    if (heading) heading.textContent = 'Confirm Your Details';
  }

  /* ── Form Live Validation ── */
  var mainForm = document.getElementById('participate-form-step-1');
  if (mainForm) {
    var submitBtn = mainForm.querySelector('.participate-form__submit-btn');

    function checkFormValidity() {
      var isValid = true;

      /* Check required inputs */
      mainForm.querySelectorAll('[required]').forEach(function (field) {
        if (field.type === 'checkbox') {
          if (!field.checked) isValid = false;
        } else if (field.type === 'file') {
          /* File upload is now optional, no required check needed */
        } else {
          if (!field.value.trim()) {
            isValid = false;
          } else if (field.type === 'email') {
            var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailRegex.test(field.value)) isValid = false;
          } else if (field.type === 'tel') {
            var phoneRegex = /^[0-9]{10}$/;
            if (!phoneRegex.test(field.value)) isValid = false;
          }
        }
      });

      /* Additional check for second checkbox (even if not strictly [required] in HTML, user wants it) */
      var cb2 = mainForm.querySelector('[name="terms_2"]');
      if (cb2 && !cb2.checked) isValid = false;

      if (submitBtn) {
        if (isValid) submitBtn.classList.add('is-ready');
        else submitBtn.classList.remove('is-ready');
      }
    }

    mainForm.querySelectorAll('input, select, textarea').forEach(function (el) {
      el.addEventListener('input', checkFormValidity);
      el.addEventListener('change', checkFormValidity);
    });

    /* Initial check */
    checkFormValidity();

    /* ── Hook into form submit ── */
    mainForm.addEventListener('submit', function (e) {
      e.preventDefault();

      if (!submitBtn.classList.contains('is-ready')) return;

      /* First submission → open quiz */
      if (!submitBtn.dataset.quizDone) {
        var step1Main = document.querySelector('.participate-step[data-step="1"]');
        var step2Main = document.querySelector('.participate-step[data-step="2"]');
        if (step1Main) { step1Main.classList.remove('active'); step1Main.classList.add('completed'); }
        if (step2Main) { step2Main.classList.add('active'); }
        openQuiz();
        return;
      }

      /* Second submission (Confirm Your Entry) → collect + send */
      var quizAnswers = window._quizAnswers || { q1: 'Wrong', q2: 'Wrong', q3: 'Wrong' };
      var rawOrderId = mainForm.querySelector('[name="order_number"]') ? mainForm.querySelector('[name="order_number"]').value : '';
      
      function generateID(length) {
        var result = '';
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
        for (var i = 0; i < length; i++) {
          result += characters.charAt(Math.floor(Math.random() * characters.length));
        }
        return result;
      }
      var uniqueID = generateID(10);
      var formattedOrderId = rawOrderId + '-' + uniqueID;
      window._lastEntryRef = formattedOrderId;

      var fileInput = mainForm.querySelector('#invoice-file-input');
      var file = fileInput && fileInput.files && fileInput.files.length > 0 ? fileInput.files[0] : null;

      function submitPayload(fileBase64, fileName, mimeType) {
        var payload = {
          name:      mainForm.querySelector('[name="name"]') ? mainForm.querySelector('[name="name"]').value : '',
          email:     mainForm.querySelector('[name="email"]') ? mainForm.querySelector('[name="email"]').value : '',
          phone:     mainForm.querySelector('[name="mobile"]') ? mainForm.querySelector('[name="mobile"]').value : '',
          dob:       mainForm.querySelector('[name="date_of_birth"]') ? mainForm.querySelector('[name="date_of_birth"]').value : '',
          platform:  mainForm.querySelector('[name="purchase_source"]') ? mainForm.querySelector('[name="purchase_source"]').value : '',
          orderid:   formattedOrderId,
          question1: quizAnswers.q1,
          question2: quizAnswers.q2,
          question3: quizAnswers.q3,
          result:    ([quizAnswers.q1, quizAnswers.q2, quizAnswers.q3].filter(function(r){ return r.indexOf('(Correct)') > -1; }).length >= 2) ? 'Pass' : 'Fail',
          fileBase64: fileBase64,
          fileName: fileName,
          mimeType: mimeType,
          folderId: googleSettings.folder_id || "1HTiccOgWLJbo9V-HhAf9z-ZeSxP0No6N"
        };

        var SHEET_URL = googleSettings.script_url || 'https://script.google.com/macros/s/AKfycbxJZwK-t09oJRNfeg02qY89WpFNCYPvFCpWihYmMpvcEuUU1LKYACwvtuBQqbgDPpuoZA/exec';

        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting…';

        fetch(SHEET_URL, {
          method: 'POST',
          mode: 'no-cors',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function () {
          showThankYou();
        })
        .catch(function () {
          showThankYou();
        });
      }

      if (file) {
        var reader = new FileReader();
        reader.onload = function(e) {
          var base64 = e.target.result.split(',')[1];
          submitPayload(base64, file.name, file.type);
        };
        reader.readAsDataURL(file);
      } else {
        submitPayload('', '', '');
      }
    });
  }

  function showThankYou() {
    /* ── Right side: hide form, show thank-you panel ── */
    var form   = document.getElementById('participate-form-step-1');
    var tyBlock = document.getElementById('anniversary-thankyou-block');
    if (form)    form.style.display = 'none';
    if (tyBlock) tyBlock.classList.add('is-visible');

    /* ── Left side: hide normal content + steps, show TY panel ── */
    var normalHeading = document.getElementById('participate-heading-normal');
    var normalSteps   = document.getElementById('participate-steps-normal');
    var tyLeft        = document.getElementById('participate-thankyou-left');
    if (normalHeading) normalHeading.style.display = 'none';
    if (normalSteps)   normalSteps.style.display   = 'none';
    if (tyLeft)        tyLeft.style.display        = 'flex';

    /* ── Fill user name in left description ── */
    var nameInput = document.getElementById('participant-name');
    var tyNameLeft = document.getElementById('ty-user-name-left');
    if (tyNameLeft && nameInput) tyNameLeft.textContent = nameInput.value;

    /* ── Fill entry reference ── */
    var tyRef = document.getElementById('ty-entry-ref');
    if (tyRef && window._lastEntryRef) tyRef.textContent = window._lastEntryRef;

    /* ── Copy button ── */
    var copyBtn = document.getElementById('ty-copy-btn');
    if (copyBtn && tyRef) {
      copyBtn.addEventListener('click', function () {
        var txt = tyRef.textContent;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(txt);
        } else {
          var tmp = document.createElement('textarea');
          tmp.value = txt;
          document.body.appendChild(tmp);
          tmp.select();
          document.execCommand('copy');
          document.body.removeChild(tmp);
        }
        copyBtn.textContent = 'Copied!';
        setTimeout(function () { copyBtn.innerHTML = 'Copy <svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M9.5 0H3.5C2.67157 0 2 0.671573 2 1.5V8.5H3V1.5C3 1.22386 3.22386 1 3.5 1H9.5V0ZM10.5 2H5C4.17157 2 3.5 2.67157 3.5 3.5V10.5C3.5 11.3284 4.17157 12 5 12H10.5C11.3284 12 12 11.3284 12 10.5V3.5C12 2.67157 11.3284 2 10.5 2ZM11 10.5C11 10.7761 10.7761 11 10.5 11H5C4.72386 11 4.5 10.7761 4.5 10.5V3.5C4.5 3.22386 4.72386 3 5 3H10.5C10.7761 3 11 3.22386 11 3.5V10.5Z" fill="#1B11B2"/></svg>'; }, 2000);
      });
    }
  }

})();
